export default "__VITE_ASSET__CyVdq10C__"